import React from 'react';

const PersonalizedFoodCompo = () => {
    return (
        <div className='mx-auto lg:mb-20 md:mb-16 sm:mb-10 mb-10'>
            <h1 className='text-md my-5'>Sometimes we need a little guidance and that’s alright! We have
                a solution for those who need a guide every step of the way. This
                program is a day-by-day food plan for 90 days.</h1>

        </div>
    );
};

export default PersonalizedFoodCompo;